module.exports = __webpack_public_path__ + "media/components/footer/static/placeholder-fe2ca5ca3848855097354c2ccaea0b9f.svg";